<template>
  <div class="totallist-wrap">
    <div class="tab-card" v-if="loading === false && !data">
      <empty :tag="false" />
    </div>
    <div v-else-if="data">
      <div class="tips">提示：每日0点更新数据一次</div>
      <van-grid :column-num="2" :gutter="20" :border="false">
        <van-grid-item class="bg-item-img-1">
          <div>
            <div class="grid-item-img">
              <picture>
                <source
                  srcset="@/assets/img/result-score.png"
                  type="image/png"
                />
              </picture>
            </div>
            <!-- <div class="value">{{ data && data.score ? data.score : "--" }}</div> -->
            <div class="value">
              {{ data && data.score_total ? data.score_total : "--" }}
            </div>
            <div class="label">累计分数</div>
            <van-icon
              class="calc-desc"
              name="info-o"
              color="#9ec3f8"
              @click="emitTip(1)"
            />
          </div>
        </van-grid-item>

        <van-grid-item class="bg-item-img-2">
          <div class="grid-item-img">
            <picture>
              <source srcset="@/assets/img/result-top.png" type="image/png" />
            </picture>
          </div>

          <div class="value">{{ data && data.rank ? data.rank : "--" }}</div>
          <div class="label">总排名</div>
          <van-icon
            class="calc-desc"
            name="info-o"
            color="#9ec3f8"
            @click="emitTip(2)"
          />
        </van-grid-item>
        <van-grid-item class="bg-item-img-3">
          <div class="grid-item-img">
            <picture>
              <source srcset="@/assets/img/result-rate.png" type="image/png" />
            </picture>
          </div>

          <div
            v-if="data && data.accuracy && Number(data.accuracy) > 0"
            class="value"
          >
            <!-- {{ accuracy | percentFormat(1) }}% -->
            {{ Number(data.accuracy) * 10 }}%
          </div>
          <div v-else class="value">--</div>
          <div class="label">答题正确率</div>
          <van-icon
            class="calc-desc"
            name="info-o"
            color="#9ec3f8"
            @click="emitTip(3)"
          />
        </van-grid-item>
        <van-grid-item class="bg-item-img-4">
          <div class="grid-item-img">
            <picture>
              <source
                srcset="@/assets/img/result-duration.png"
                type="image/png"
              />
            </picture>
          </div>
          <div class="value">
            <!-- {{ data.duration | durationFormat("HH:mm:ss") }} -->
            <!-- {{ data && data.duration_format ? data.duration_format : "--" }} -->
            {{ data && data.duration_total ? data.duration_total : "--" }}
          </div>
          <div class="label">累计时长</div>
          <van-icon
            class="calc-desc"
            name="info-o"
            color="#9ec3f8"
            @click="emitTip(4)"
          />
        </van-grid-item>
      </van-grid>
    </div>
  </div>
</template>
<script>
import Empty from "./Empty";
export default {
  components: {
    Empty,
  },
  data() {
    return {
      loading: false,
      data: null,
    };
  },
  // computed: {
  //   accuracy() {
  //     if (this.data && Number(this.data.times) > 0) {
  //       return Number(this.data.score) / Number(this.data.times) / 5;
  //     } else {
  //       return 0;
  //     }
  //   },
  // },
  methods: {
    async getData() {
      try {
        this.loading = true;
        const res = await this.$axios.post(`/Statis/getStatsUser`);
        this.data = res?.data ?? null;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || "获取总成绩数据发生错误",
          duration: 2000,
        });
      } finally {
        this.loading = false;
      }
    },
    emitTip(type) {
      this.$emit("show-tip", type);
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.totallist-wrap {
  min-height: calc(100vh - 46px);
  overflow: hidden;
  .tips {
    padding: 10px 0;
    font-size: 14px;
    line-height: 14px;
    color: #666;
    text-align: center;
  }
  .van-grid {
    margin-top: 10px;
    .van-grid-item {
      position: relative;
      .calc-desc {
        position: absolute;
        top: 20px;
        right: 32px;
        font-size: 22px;
        ::before {
          font-size: 15px;
        }
      }
    }

    .bg-item-img-1 {
      ::v-deep .van-grid-item__content {
        text-align: center;
        background: url("~@/assets/img/result-score.png") no-repeat center
          center;
        background-size: contain;
      }
    }
    .bg-item-img-2 {
      ::v-deep .van-grid-item__content {
        text-align: center;
        background: url("~@/assets/img/result-top.png") no-repeat center center;
        background-size: contain;
      }
    }
    .bg-item-img-3 {
      ::v-deep .van-grid-item__content {
        text-align: center;
        background: url("~@/assets/img/result-rate.png") no-repeat center center;
        background-size: contain;
      }
    }
    .bg-item-img-4 {
      ::v-deep .van-grid-item__content {
        text-align: center;
        background: url("~@/assets/img/result-duration.png") no-repeat center
          center;
        background-size: contain;
      }
    }
    .grid-item-img {
      width: 100px;
      height: 100px;
      padding-top: 10px;
    }
    .icon {
      width: 100%;
      vertical-align: top;
    }
    .value {
      margin: 10px 0;
      font-size: 25px;
      font-weight: bold;
      color: #0148f4;
    }
    .label {
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: 400;
      line-height: 1;
      color: $black;
    }
  }
}
</style>
